import {Link} from "react-router-dom";
import React from "react";

export default function BreadCrumbs({path}: { path: string }) {
    let segments = path.split(".");

    return (
        <div className="breadcrumbs">
            <div className="flex space-x-2">
                <Link to="/note" className={path === "" ? "text-primary-16" : ""} key=":">:</Link>
                {path !== "" ? <span key="delimiter_-1">/</span> : null}

                {segments.map((segment, index) => {
                    return (<>
                        <Link to={"/note/" + segments.slice(0, index + 1).join(".")}
                              className={index === segments.length - 1 ? "text-primary-16" : ""}
                              key={segments.slice(0, index).join(".")}>{segment}</Link>
                        {index !== segments.length - 1 ? <span key={"delimiter_" + index}>/</span> : null}
                    </>)
                })}
            </div>
        </div>
    );
}